// extracted by mini-css-extract-plugin
export default {"factorContainer":"active-factors_factorContainer__fuYjk","activeBadge":"active-factors_activeBadge__qKOZs"};